module.exports = __webpack_public_path__ + "img/wakaf.ab728043.png";